import classNames from 'clsx';
import React from 'react';

import type { Props as NavProps, NavStyleProps } from '../StarsNavItem/StarsNavItem';
import StarsNavItem from '../StarsNavItem/StarsNavItem';

export interface Props {
  list: NavProps[];
  isOpen: boolean;
  classes: NavStyleProps['classes'];
  indent?: number;
}

const StarsNavList: React.FC<Props> = ({ list, isOpen, classes, indent = 0 }) => (
  <ul className={classNames(classes.navList, isOpen && classes.open)}>
    {list.map((item, i) => (
      <StarsNavItem key={i} {...item} classes={classes} indent={indent} />
    ))}
  </ul>
);

export default StarsNavList;
